import animation, { cubicBezier } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import React from "react"
import styled from "styled-components"

const Button = styled.button`
  display: flex;
  padding: 12px;
  background-color: transparent;
  border: none;
  &:active,
  &:focus,
  &:hover {
    outline: none;
  }

  @media ${breakpoints.laptop} {
    &:hover {
      cursor: pointer;
    }
  }
`

const Background = styled.div<
  Pick<SwitchButtonProps, "active" | "activeBackgroundColor">
>`
  display: flex;
  width: 28px;
  height: 16px;
  align-items: center;
  justify-content: flex-start;
  background-color: ${({ active, activeBackgroundColor }) =>
    active ? activeBackgroundColor || colors.black : "#B5B5B5"};
  border-radius: 100px;
`

const Control = styled.span<Pick<SwitchButtonProps, "active">>`
  width: 12px;
  height: 12px;
  transform: translateX(${({ active }) => (active ? "14.5px" : "1.5px")});
  transition: transform ${animation.medium} ${cubicBezier};
  background-color: ${colors.white};
  border-radius: 50%;
`

interface SwitchButtonProps {
  active: boolean
  activeBackgroundColor?: string
  ariaLabel?: string
  onClick?: (event) => void
}

const SwitchButton: React.FC<SwitchButtonProps> = ({
  active,
  activeBackgroundColor,
  ariaLabel,
  onClick,
}) => {
  return (
    <Button aria-label={ariaLabel} onClick={onClick}>
      <Background active={active} activeBackgroundColor={activeBackgroundColor}>
        <Control active={active} />
      </Background>
    </Button>
  )
}

export default SwitchButton
